import { Component, Input, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { constants } from 'src/app/components/monitor/services/constants';

@Component({
    selector: 'validate-form',
    templateUrl: './validate-form.component.html',
    styleUrls: ['./validate-form.component.css'],
    standalone: true,
    imports: [TranslateModule]
})
export class ValidateFormComponent implements OnInit {

  @Input() message:any;
  @Input() customClass:any;
  @Input() fieldName:any  = {
    invalid:false,
    dirty:false,
    errors:null
  };

  myerrors:any;
  @Input() serverErrors:any;
  
  requiredMsg:boolean = false;
  minlengthMsg:boolean = false;
  maxlengthMsg:boolean = false;
  emailMsg:boolean = false;
  mustMatchMsg:boolean = false;
  newClass:string = "text-danger validation-container";

  constructor() { }

  ngOnInit(): void {
    if (constants.__isNoEmpty(this.customClass)) {
      this.newClass = this.customClass+" validation-container";
    }

  }

  log(text:any) {
    
  }

}
